<div>
  <h4>View vital:</h4>
  <p-select [options]="viewableVitals()" [(ngModel)]="selectedVital" (onChange)="onViewChange()"></p-select>
</div>

@if (hasData) {
  <div echarts [options]="options" class="vitals-chart" (chartInit)="onChartInit($event)"></div>
}